<style scoped lang="scss">
    .ordersuccess {
        text-align: center;
        padding: 40px;
        line-height: 160px;
        font-size: 24px;
        font-weight: 500;

        img {
            vertical-align: middle;
        }
    }

    .card {
        width: 1200px;
        margin: auto;
        box-shadow: 0 0 10px #eee;

        .header {
            padding: 20px 40px;
            font-size: 18px;
            border-bottom: 1px solid #eee;
        }

        .card-txt {
            padding: 20px 44px;

            .row {
                padding: 7px 0;
                display: flex;
                flex-direction: row;
                font-size: 16px;
                line-height: 30px;

                label {
                    width: 140px;
                    color: #999;
                }

                div {
                    flex: 1;
                    text-align: right;

                    p {
                        margin: 0;
                        padding: 0;
                        line-height: 30px;
                    }

                }
            }
        }
    }

    .payment {
        margin-top: 40px;
        margin-bottom: 40px;

        .item {
            margin-top: 10px;
            line-height: 30px;
            cursor: pointer;

            i {
                font-size: 30px;
                color: #999;
                width: 50px;

                &.active {
                    color: #90ca6f;
                }
            }

            img {
                display: block;
                width: 30px;
                height: 30px;
            }

            div {
                flex: 1;
                font-size: 16px;
                padding-left: 20px;

                .desc {
                    color: #999;
                }
            }
        }

        .paybtn {
            text-align: right;
            padding: 10px 0;

            button {
                width: 180px;
                background: #e23844;
                border: none;
                outline: none;
                height: 50px;
                text-align: center;
                line-height: 50px;
                font-size: 20px;
                color: white;
                cursor: pointer;
            }
        }
    }

    .payToBank {
        .row {
            height: 36px;
            line-height: 36px;
            border-bottom: 1px dashed #e5e5e5;
            display: flex;
            flex-direction: row;
            padding-top: 5px;

            .l {
                flex: 1;

                span {
                    padding-left: 20px;
                    font-weight: 600;
                }
            }

            .copy {
                i {
                    color: #888;
                }

                color: #888;
                cursor: pointer;
                width: 70px;
                text-align: right;
            }
            .content {
                color: #606266;
                font-size: 14px;
                font-weight: 600;
            }
        }

        .upload {
            padding-top: 20px;
        }

        .avatar-uploader ::v-deep .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }

        .avatar-uploader ::v-deep .el-upload:hover {
            border-color: #409EFF;
        }

        .avatar-uploader-icon {
            width: 220px;
            height: 150px;

            i {
                font-size: 28px;
                color: #8c939d;
                padding-top: 30px;
                width: 220px;
                height: 50px;
                line-height: 50px;
                text-align: center;
            }
        }

        .avatar {
            width: 220px;
            height: 150px;
            display: block;
        }

        .qrcodeDesc {
            text-align: center;
        }

        .qrcode {
            text-align: center;
        }
    }

    .back{
        text-align: center;
        padding: 30px 0;
        button{
            background: #90ca6f;
            border: none;
            font-size: 20px;
            padding: 15px 30px;
            color: white;
            border-radius: 5px;
        }

    }

    ::v-deep .el-dialog {
        width: 80%;
        max-width: 500px;
    }

    ::v-deep .el-dialog__body {
        padding: 10px 20px;
    }
</style>
<template>
    <div v-loading="loading">
        <div class="ordersuccess">
            <img src="../../assets/frontend/images/img_tijiao@2x.png" alt=""/>请确认订单详情并支付！
        </div>
        <div class="card">
            <div class="header">
                订单详情
            </div>
            <div class="card-txt" v-if="order">
                <div class="row">
                    <label>订单号</label>
                    <div>{{order.id}}</div>
                </div>
                <div class="row">
                    <label>订单产品</label>
                    <div>
                        <p v-for="item in order.items">{{item.commodityName}} x{{item.quantity}} <span style="padding-left: 20px;">{{ getPriceType(order.priceType).symbol }}{{item.commodityPrice}} {{ getPriceType(order.priceType).unit }}</span></p>
                    </div>
                </div>
                <div class="row">
                    <label>订单总金额</label>
                    <div class="">{{ getPriceType(order.priceType).symbol }}{{order.totalAmount}} {{ getPriceType(order.priceType).unit }}</div>
                </div>
                <div class="row">
                    <label>商品金额</label>
                    <div class="">{{ getPriceType(order.priceType).symbol }}{{order.productsAmount}} {{ getPriceType(order.priceType).unit }}</div>
                </div>
                <div class="row">
                    <label>快递运费</label>
                    <div class="">{{ getPriceType(order.priceType).symbol }}{{order.freight}} {{ getPriceType(order.priceType).unit }}</div>
                </div>
                <div class="row" v-if="order.needTakePhoto">
                    <label>标记拍照服务费</label>
                    <div class="">{{ getPriceType(order.priceType).symbol }}{{order.takePhotoAmount}} {{ getPriceType(order.priceType).unit }}</div>
                </div>
                <div class="row" v-if="order.serviceAmount>0 && order.payStatus === 2">
                    <label>手续费</label>
                    <div class="">{{ getPriceType(order.priceType).symbol }}{{order.serviceAmount}} {{ getPriceType(order.priceType).unit }}</div>
                </div>
                <div class="row" v-if="order.cashAmount>0">
                    <label>余额抵扣</label>
                    <div class="">-{{ getPriceType(order.priceType).symbol }}{{order.cashAmount}} {{ getPriceType(order.priceType).unit }}</div>
                </div>
                <div class="row" v-if="order.couponAmount>0">
                    <label>优惠券抵扣</label>
                    <div class="">-{{ getPriceType(order.priceType).symbol }}{{order.couponAmount}} {{ getPriceType(order.priceType).unit }}</div>
                </div>
                <div class="row">
                    <label>应付金额</label>
                    <div class="red">{{ getPriceType(order.priceType).symbol }}{{order.paymentAmount}} {{ getPriceType(order.priceType).unit }}</div>
                </div>
                <div class="row" v-if="!order.tenantId">
                    <label>收件人</label>
                    <div>{{order.addressee.name}}，{{order.addressee.tel}}，{{order.addressee.detail}}</div>
                </div>
                <div class="row" v-else>
                    <label>取货方式</label>
                    <div>自提</div>
                </div>
                <div class="row">
                    <label>寄件人</label>
                    <div>{{order.consignor.name}}，{{order.consignor.tel}}</div>
                </div>
                <div class="row">
                    <label>订单备注</label>
                    <div>{{order.remak}}</div>
                </div>
            </div>
        </div>

        <!--未支付才显示-->
        <div class="card payment" v-if="order && order.payStatus===0">
            <div class="header" v-if="!order.priceType">
                支付方式
            </div>
            <div class="card-txt">
                <div v-if="!order.priceType">
                    <div class="item rowflex" @click="payment=1">
                        <i :class="{'iconfont':true, 'icon-xuanze':true, active:payment === 1}"></i>
                        <img src="../../assets/frontend/images/icon_wx@2x.png" alt=""/>
                        <div>
                            微信支付<br/>
                            <span class="desc" v-if="!order.priceType">
                                手续费{{ amountRate }}%，<br/>
                                您将按照当前汇率支付人民币，需要您的微信绑定了国内银行卡，并进行过实名认证。
                            </span>
                        </div>
                    </div>

                    <div v-if="order.priceType"><br /></div>

                    <div class="item rowflex" @click="payment=2">
                        <i :class="{'iconfont':true, 'icon-xuanze':true, active:payment === 2}"></i>
                        <img src="../../assets/frontend/images/icon_ZFB@2x.png" alt=""/>
                        <div>
                            支付宝支付<br/>
                            <span class="desc" v-if="!order.priceType">
                                手续费{{ amountRate }}%，<br/>
                                您将按照当前汇率支付人民币，需要您的微信绑定了国内银行卡，并进行过实名认证。
                            </span>
                        </div>
                    </div>

                    <div class="item rowflex" @click="payment=3" v-if="!order.priceType">
                        <i :class="{'iconfont':true, 'icon-xuanze':true, active:payment === 3}"></i>
                        <img src="../../assets/frontend/images/icon_yh@2x.png" alt=""/>
                        <div>
                            银行卡转账<br/>
                            <span class="desc">
                            澳洲银行转账。
                        </span>
                        </div>
                    </div>
                </div>
                <div class="paybtn">
                    <button @click="payHandle">确认支付</button>
                </div>
            </div>
        </div>
        <div class="card back" v-else>
            <button @click="$router.push('/orders')">支付完成，返回订单列表</button>
        </div>

        <!--支付-->
        <el-dialog :title="paymentName" :visible.sync="payDialogVisible" :close-on-click-modal="false"
                   v-if="order" v-loading="payLoading">
            <div class="payToBank" v-if="payDialogVisible && payment===3">
                <div class="row">
                    <div class="l">银行:<span></span></div>
                    <div class="content">{{bankInfo.bank}}</div>
                    <div class="copy" v-if="false"><i class="el-icon-document-copy"></i>复制</div>
                </div>
                <div class="row">
                    <div class="l">账户:<span></span></div>
                    <div class="content">{{bankInfo.name}}</div>
                    <div class="copy" v-if="false"><i class="el-icon-document-copy"></i>复制</div>
                </div>
                <div class="row">
                    <div class="l">BSB:<span></span></div>
                    <div class="content">{{bankInfo.bsb}}</div>
                    <div class="copy" v-if="false"><i class="el-icon-document-copy"></i>复制</div>
                </div>
                <div class="row">
                    <div class="l">账号:<span></span></div>
                    <div class="content">{{bankInfo.cardNo}}</div>
                    <div class="copy" v-if="false"><i class="el-icon-document-copy"></i>复制</div>
                </div>
                <div class="row">
                    <div class="l">金额:<span></span></div>
                    <div class="content">{{ getPriceType(order.priceType).symbol }}{{bankInfo.money}}</div>
                    <div class="copy" v-if="false"><i class="el-icon-document-copy"></i>复制</div>
                </div>
                <div class="row">
                    <div class="l">请备注订单号:<span></span></div>
                    <div class="content">{{bankInfo.remark}}</div>
                    <div class="copy" v-if="false"><i class="el-icon-document-copy"></i>复制</div>
                </div>
                <div class="upload">
                    <el-upload
                        class="avatar-uploader"
                        accept="image/jpeg,image/gif,image/png"
                        :action="uploadUrl"
                        :headers="uploadHeaders"
                        :show-file-list="false"
                        :on-success="uploadSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="uploadImage" :src="uploadImage"
                             class="avatar">
                        <div v-else class="avatar-uploader-icon">
                            <i class="el-icon-plus"></i><br/>
                            请上传银行转账截图
                        </div>
                    </el-upload>
                </div>
            </div>

            <div class="payToBank" v-if="payment!==3">
                <div class="row">
                    <div class="l">订单金额:<span></span></div>
                    <div class="content">{{ getPriceType(order.priceType).symbol }}{{order.totalAmount}}</div>
                    <div class="copy" v-if="false"><i class="el-icon-document-copy"></i>复制</div>
                </div>
                <div class="row" v-if="!order.priceType">
                    <div class="l">手&nbsp;&nbsp;续&nbsp;&nbsp;费:<span></span></div>
                    <div class="content">{{ getPriceType(order.priceType).symbol }}{{serviceAmount}}</div>
                    <div class="copy" v-if="false"><i class="el-icon-document-copy"></i>复制</div>
                </div>
                <div class="row">
                    <div class="l">支付总额:<span></span></div>
                    <div class="content">{{ getPriceType(order.priceType).symbol }}{{totalAmounts}}</div>
                    <div class="copy" v-if="false"><i class="el-icon-document-copy"></i>复制</div>
                </div>
                <div class="row">
                    <div class="l">订单号:<span></span></div>
                    <div class="content">{{order.id}}</div>
                    <div class="copy" v-if="false"><i class="el-icon-document-copy"></i>复制</div>
                </div>
                <div class="qrcode" style="margin: 10px 0;">
                    <qriously :value="wxQRCode" v-if="payment===1" :size="250" style="width: 250px; heigth: 250px; display: block; margin: 0 auto;"></qriously>
                    <qriously :value="alipayQRCode" v-if="payment===2" :size="250" style="width: 250px; heigth: 250px; display: block; margin: 0 auto;"></qriously>
                    <!--<img :src="wxQRCode" alt="" v-if="payment===1" width="250" height="250"/>
                    <img :src="alipayQRCode" alt="" v-if="payment===2" width="250" height="250"/>-->
                </div>
                <div class="qrcodeDesc">{{ paymentInfo }}</div>
            </div>

            <div slot="footer" class="dialog-footer" v-if="payment===3">
                <el-button @click="payDialogVisible=false">取 消</el-button>
                <el-button type="primary" @click="bankTransferCompleted">已完成转账</el-button>
            </div>
            <div slot="footer" class="dialog-footer" v-else>
                <el-button @click="payDialogVisible=false">取 消</el-button>
                <el-button type="primary" @click="paymentCompleted">支付完成</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import Vue from 'vue'
    import VueQriously from 'vue-qriously'
    Vue.use(VueQriously)
    export default {
        name: 'pay',
        data () {
            return {
                loading: true,
                payLoading: false,
                order: null,
                payment: null,
                payDialogVisible: false,
                uploadUrl: window.baseUrl + window.consts.apis.uploadFile,
                uploadImage: null,
                wxQRCode: "",
                alipayQRCode: "",
                bankInfo: {
                    "bank": "",
                    "name": "",
                    "bsb": "",
                    "cardNo": "",
                    "remark": "请备注订单号"
                },
                appConfig: {},
                amountRate: 1,   // 手续费率
                serviceAmount: 0,    // 手续费
                totalAmounts: 0 // 加了手续费的总额
            }
        },
        computed: {
            paymentName () {
                if (this.payment === 1) {
                    if (this.order.priceType) {
                        return '扫码支付'                    }
                    return '微信支付'
                } else if (this.payment === 2) {
                    return '支付宝支付'
                } else {
                    return '银行卡转账'
                }
            },
            paymentInfo() {
                if (this.payment === 1) {
                    if (this.order.priceType) {
                        return '请使用扫码工具进行扫码支付'                    }
                    return '请使用微信扫一扫进行支付'
                } else if (this.payment === 2) {
                    return '请使用支付宝扫一扫进行支付'
                } else {
                    return ''
                }
            }
        },
        created () {
            this.getOrder()
        },
        mounted () {
            this.getAppSetting()
        },
        methods: {
            getAppSetting() {
                this.axios.get(window.consts.apis.getAppSetting).then(res=>{
                    if(res.success && res.result){
                        this.appConfig = res.result
                        this.amountRate = res.result.serviceAmountRate * 100
                    }
                })
            },
            getOrder () {
                this.$axios.get(window.consts.apis.orderDetail + '?id=' + this.$route.query.orderId).then(r => {
                    this.loading = false
                    if (r.success) {
                        this.order = r.result
                    } else {
                        this.$alert(r.error.message, '')
                    }
                }).catch(e => {
                    this.loading = false
                    this.$alert('未知错误', '')
                })
            },
            payHandle () {
                if (this.order.priceType) {
                    this.payment = 1
                }
                if (this.payment) {
                    this.payDialogVisible = true
                    // 人民币支付
                    if (this.order.priceType) {
                        this.totalAmounts = this.toFixed(this.order.paymentAmount)
                        this.payLoading = true
                        let url = window.consts.apis.payCashier + '?orderId=' + this.order.id
                        this.$axios.get(url).then(() => {
                            url = window.baseUrl + url
                            this.payLoading = false
                            this.wxQRCode = url
                            this.alipayQRCode = url
                        })
                    }
                    // 澳币支付
                    else if (this.payment === 1 && !this.wxQRCode) {
                        console.log('生成微信二维码')
                        // 准确计算手续费
                        let curRate = this.operationAddOrSub('+', 1, this.appConfig.serviceAmountRate)
                        let multiAmount = this.operationMulti(this.order.paymentAmount, curRate)
                        this.serviceAmount = this.toFixed(this.operationMulti(this.order.paymentAmount, this.appConfig.serviceAmountRate))
                        this.totalAmounts = this.toFixed(multiAmount)
                        this.payLoading = true
                        this.$axios.post(window.consts.apis.pcPayQrCode + '?' + this.jsonToUrlParams({
                            orderId: this.order.id,
                            paymentType: 1
                        })).then(r => {
                            this.payLoading = false
                            if (r.success) {
                                this.wxQRCode = r.result
                            } else {
                                if (r.error.message.indexOf('exists') > 0) {
                                    this.$alert('该订单已生成过支付码，不能更换支付方式', '')
                                } else {
                                    this.$alert(r.error.message, '')
                                }
                                this.payDialogVisible = false
                            }
                        })
                    } else if (this.payment === 2 && !this.alipayQRCode) {
                        console.log('生成阿里二维码')
                        // 准确计算手续费
                        let curRate = this.operationAddOrSub('+', 1, this.appConfig.serviceAmountRate)
                        let multiAmount = this.operationMulti(this.order.paymentAmount, curRate)
                        this.serviceAmount = this.toFixed(this.operationMulti(this.order.paymentAmount, this.appConfig.serviceAmountRate))
                        this.totalAmounts = this.toFixed(multiAmount)
                        this.payLoading = true
                        this.$axios.post(window.consts.apis.pcPayQrCode + '?' + this.jsonToUrlParams({
                            orderId: this.order.id,
                            paymentType: 0
                        })).then(r => {
                            this.payLoading = false
                            if (r.success) {
                                this.alipayQRCode = r.result
                            } else {
                                if (r.error.message.indexOf('exists') > 0) {
                                    this.$alert('该订单已生成过支付码，不能更换支付方式', '')
                                } else {
                                    this.$alert(r.error.message, '')
                                }
                                this.payDialogVisible = false
                            }
                        })
                    } else if (this.payment === 3) {
                        this.serviceAmount = 0
                        this.totalAmounts = this.order.paymentAmount
                        this.payLoading = true
                        this.$axios.get(window.consts.apis.bankInfo).then(r => {
                            this.payLoading = false
                            if (r.success) {
                                //this.bankInfo = r.result
                                for (var i in r.result) {
                                    this.bankInfo[i] = r.result[i];
                                }
                                console.log(this.bankInfo);
                                this.bankInfo.money = this.order.paymentAmount;
                                this.bankInfo.remark = this.order.id;
                            } else {
                                this.$alert(r.error.message, '')
                                this.payDialogVisible = false
                            }
                        })
                    }
                } else {
                    this.serviceAmount = 0
                    this.totalAmounts = this.order.paymentAmount
                    this.$message({
                        message: '请选择支付方式',
                        type: 'warning'
                    })
                }
            },
            cancelForm () {
            },
            paymentCompleted () {
                this.$router.push({path:'/orders'});
            },
            bankTransferCompleted () {
                if (!this.uploadImage) {
                    this.$message({
                        message: '请上传银行转账截图',
                        type: 'warning'
                    })
                    return false
                }
                let transPay = {
                    transferImage: this.uploadImage,
                    id: this.order.id
                };
                this.$axios.post(window.consts.apis.transferPay, transPay).then(res => {
                    if (res.success) {
                        this.$alert("已成功上传转账截图!核对转账是人工处理过程，请耐心等待。核对之后，您的订单支付状态才会变为已支付。" ).then(r => {
                            this.payDialogVisible = false;
                            this.$router.push({path:'/orders'});
                            //this.$router.push({ path: '/m/pendingpayment/1', query: { orderId: this.order.id }});
                        });
                    } else {
                        this.$message.error("上传截图失败,请稍候再试!")
                        this.payDialogVisible = false;
                    }
                })
                //this.payDialogVisible = false;
                //this.$router.push({path:'/orders'});
                // todo
            },
            uploadSuccess (res, file) {
                this.uploadImage = res.result.fileUrl
            },
            beforeAvatarUpload (file) {
                const isLt2M = file.size / 1024 / 1024 < 2
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!')
                    return false
                }
                return true
            }
        }

    }
</script>


